import React from "react";
// COMPONENTS
import Footer from "Components/Footer/Footer";
// STYLES
import { SiteGlobalTheme } from "./WebsiteTheme.style";

/**
 * The shared site Footer in the new page palette (light tint background, navy text, blue links),
 * the same footer the Home and About pages use. Pass Footer's own props through (e.g. isCTAHidden).
 */
const SiteFooter = (props) => (
	<>
		<SiteGlobalTheme />
		<div className="sm_site_footer">
			<Footer {...props} />
		</div>
	</>
);

export default SiteFooter;
